import type { SmeCompany } from '@/types';
import { getSme, putSme } from '@/utils/request';
import { defineStore } from 'pinia';
import { uploadImages } from '@/utils/upload';
import { ref } from 'vue';

export const useSmeCompaniesStore = defineStore('sme-companies', () => {
  const companies = ref<SmeCompany[]>([]);
  const company = ref<SmeCompany | null>(null);

  const getCompanies = async (): Promise<SmeCompany[]> => {
    const data = await getSme('/companies');
    companies.value = data;
    return data;
  };

  const getCompany = async (id: string): Promise<SmeCompany> => {
    const data = await getSme(`/companies/${id}`);
    company.value = data;
    return data;
  };

  const doUpdateCompanyDetails = async (form: any) => {
    const { files } = form;
    if (files && files.length > 0) {
      await uploadImages(files, 'company_id', form.id, '/companies/logo/upload', true);
    }

    const updatedCompany = await putSme(`/companies/${form.id}`, form);

    if (company.value?.id === updatedCompany.id) {
      company.value = { ...company.value, ...updatedCompany };
    }

    const index = companies.value.findIndex(c => c.id === updatedCompany.id);
    if (index !== -1) {
      companies.value[index] = { ...companies.value[index], ...updatedCompany };
    }

    return updatedCompany;
  };

  return {
    companies,
    company,
    getCompanies,
    getCompany,
    doUpdateCompanyDetails,
  };
});
